export default "__VITE_ASSET__D2$BYm9x__"